import lang from '@/lang'
import { toast } from '@/modules/base/components/toast/toastConfig'
import React, { useEffect } from 'react'
import { Route, useNavigate, useOutletContext } from 'react-router'
import { user } from 'ampersand-app'
import { Box, Button, Typography } from '@mui/material'
import { PublicAccessContextType } from '@/modules/layout/components/public-access-layout'

const buhlKontoRoutes = (
  <>
    <Route path='buhlkonto/connected' Component={() => {
      const navigate = useNavigate()
      const outletContext = useOutletContext<PublicAccessContextType>()

      useEffect(() => {
        setTimeout(() => {
          if (user.loggedIn) {
            navigate('/taxReports#buhlArchiv-connection')
          }
        }, 100)
      }, [user.loggedIn, navigate])

      useEffect(() => {
        outletContext.setHideSidebar(true)

        toast.showToast({
          message: lang.buhlArchiv.connection.toast.connected,
          type: 'success',
        })

        return () => {
          outletContext.setHideSidebar(false)
        }
      }, [])

      return (
        <Box display='flex' flexDirection='column' gap={2} alignItems='center' justifyContent='center' height='100%'>
          <Typography variant='h4'>{lang.buhlArchiv.connection.toast.connected}</Typography>
          {!user.loggedIn && <Button variant='contained' color='primary' size='large' onClick={() => navigate('/login')}>{lang.buhlArchiv.connection.success.login}</Button>}
        </Box>
      )
    }} />
  </>
)

export default buhlKontoRoutes
